import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import ProductShowcase from './components/ProductShowcase';
import WhatIsSection from './components/WhatIsSection';
import WhyUseSection from './components/WhyUseSection';
import LifestyleBanner from './components/LifestyleBanner';
import HowToUseSection from './components/HowToUseSection';
import SafetySection from './components/SafetySection';
import ArticleCTASection from './components/ArticleCTASection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <ProductShowcase />
        <WhatIsSection />
        <WhyUseSection />
        <LifestyleBanner />
        <HowToUseSection />
        <SafetySection />
        <ArticleCTASection />
      </main>
      <Footer />
    </>
  );
}